<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">Accueil</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Gestion des tags
        </li>
      </ol>
    </nav>
    <b-modal
      id="modal-update-tag"
      :title="selectedTag ? 'Modifier un tag' : 'Ajouter un tag'"
      hide-footer
    >
      <form-tag :item="selectedTag" @sendForm="receiveUpdate" />
    </b-modal>
    <b-row>
      <b-col class="text-right">
        <b-button variant="success" @click="showModal()">Ajouter</b-button>
      </b-col>
    </b-row>
    <b-card-group deck>
      <b-card header="Liste des tags" header-tag="header">
        <b-card-group deck class="home-card">
          <b-container>
            <b-row>
              <b-col>
                <b-table :fields="fields" :items="tags" small responsive="sm">
                  <template #cell(tag_name)="row">
                    <b-badge
                      :style="{ 'background-color': row.item.tag_color }"
                      >{{ row.item.tag_name }}</b-badge
                    >
                  </template>
                  <template #cell(tag_establishments)="row">
                    {{
                      row.item.establishments
                        ? row.item.establishments.length
                        : 0
                    }}
                  </template>
                  <template #cell(update)="row">
                    <b-row>
                      <b-col>
                        <b-button
                          size="sm"
                          variant="primary"
                          @click="showModal(row.item)"
                          >Modifier</b-button
                        >
                      </b-col>
                      <b-col v-if="hasEsta(row.item)">
                        <b-button
                          size="sm"
                          variant="danger"
                          @click="receiveDelete(row.item)"
                          >Supprimer</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-container>
        </b-card-group>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
//import { mapActions, mapState } from 'vuex';
import FormTag from "../components/forms/FormTag.vue";
import { getAllTag, updateTag } from "../services/tag";
export default {
  components: {
    FormTag,
  },
  data() {
    return {
      form: {
        name: null,
        color: null,
      },
      selectedTag: null,
      fields: [
        {
          tag_name: {
            label: "Nom",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          tag_establishments: {
            label: "Nombre d'établissements associés",
            tdClass: "align-middle",
          },
        },
        {
          update: {
            label: "Actions",
            sortable: false,
            tdClass: "align-middle",
          },
        },
      ],
      tags: null,
    };
  },
  async created() {
    this.tags = await getAllTag();
  },
  methods: {
    hasEsta(item) {
      //TODO :Change if function for deleteTag exist
      return false; // !(item?.establishments?.length > 0);
    },
    async receiveUpdate(formTag) {
      const jsonForm = JSON.parse(formTag);
      const form = {
        tag_id: jsonForm.item_id,
        tag_name: jsonForm.item_name,
        tag_color: jsonForm.item_color,
      };

      this.$root.$emit("bv::hide::modal", "modal-update-tag");
      if (await updateTag(form)) this.tags = await getAllTag();
    },
    receiveDelete(tag) {
      //TODO : ADD service for this function
      // DeteteTag({tag_id: tag});
    },
    showModal(tag) {
      this.selectedTag = tag;
      this.$root.$emit("bv::show::modal", "modal-update-tag");
    },
  },
};
</script>
<style>
.home-card {
  padding: 0 15px;
}
.card {
  margin: 15px;
}
.card-body .container {
  padding: 0;
}
</style>
